var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.227,
    height: 21.36,
    viewBox: "0 0 16.227 21.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4056",
    "data-name": "Rectangle 4056",
    width: 21.36,
    height: 16.227,
    fill: "#597931"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9705",
    "data-name": "Group 9705",
    transform: "translate(0 21.36) rotate(-90)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33409",
    "data-name": "Path 33409",
    d: "M15.925,7.749h-.239q-7.33,0-14.659,0a1.581,1.581,0,0,1-.4-.034A.857.857,0,0,1,.819,6.033c.08,0,.161,0,.242,0H15.933L16,5.936a.713.713,0,0,1-.2-.1Q13.651,3.682,11.5,1.521A.866.866,0,0,1,11.4.305.856.856,0,0,1,12.6.192a2.059,2.059,0,0,1,.161.153l5.817,5.833a.884.884,0,0,1,0,1.42q-2.93,2.938-5.859,5.877a.884.884,0,0,1-.907.293.859.859,0,0,1-.427-1.39c.048-.056.1-.107.154-.16Q13.67,10.082,15.8,7.946a1.163,1.163,0,0,1,.18-.123l-.058-.073",
    transform: "translate(1.213 1.213)",
    fill: "#597931",
    stroke: "#597931",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenUpArrow);
export default __webpack_public_path__ + "static/media/green_up_arrow.2c6a5e4733998394b210a126d972a285.svg";
export { ForwardRef as ReactComponent };